import Loader from "../../components/Loader";
import styles from "./leases.module.css";
import React from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { Typography } from "@mui/material";
import { Home } from "react-feather";
import Footer from "../../components/Footer";
import LeaseGridView from "./gridview/LeaseGridView";
import LeaseListView from "./listview/LeaseListView";
import { useEffect } from "react";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";

const Leases = () => {
    const [isGridView, setIsGridView] = useState(false);
    const [hasGridRendered, setHasGridRendered] = useState(false);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", status: "" });

    useEffect(() => {
        if (localStorage.getItem("leaseStatusyFilterData")) {
            setIsGridView(true);
            setHasGridRendered(true);
        }
    }, []);

    const handleView = (view) => {
        if (view === "grid") {
            setIsGridView(true);
            setHasGridRendered(true);
        } else {
            setIsGridView(false);
        }
    }

    return (<React.Fragment>
        <Helmet title="Leases" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Leases</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Payment</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Leases</li>
                </ol>
            </nav>
        </div>

        {/* List View */}
        <div style={{ display: isGridView ? "none" : "block" }}>
            <LeaseListView isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} />
        </div>

        {/* Grid View */}
        {hasGridRendered && (<div style={{ display: isGridView ? "block" : "none" }}>
            <LeaseGridView isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} />
        </div>)}


        <Footer />
    </React.Fragment>)
}

export default withCustomAuthenticationRequired(Leases, {
    onRedirecting: () => <Loader />,
});